<proffeo-ui-dialog [title]="dialogData.title | translate">
  <div class="flex h-full w-full flex-col gap-2">
    @if (industries()) {
      <proffeo-select-industry-list
        [(selectedIndustries)]="selectedIndustries"
        [selectMode]="selectMode"
        [industries]="industries()"
      ></proffeo-select-industry-list>
    }
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      text="close"
      matDialogClose
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="save()"
      variant="accent"
      text="save-and-close"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
